import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Field, Form } from 'formik';
import { Text, Box, Button } from '@components/common';
import { InputField } from '@components/form';
import API from '@utils/api';
import { getErrors } from '@utils/error';

import validationSchema from './schema';

class ForgotForm extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func
  };

  handleSubmit = async (values, actions) => {
    const { setSubmitting, setErrors, setStatus } = actions;
    setSubmitting(true);

    try {
      await API.forgotPassword(values);
      setSubmitting(false);
      setStatus({
        message: 'Check your email for next-steps.'
      });
    } catch (err) {
      const error = getErrors(err);
      if (error.message) {
        setErrors({
          email: error.message
        });
      } else {
        setErrors(error);
      }
    }
    setSubmitting(false);
  };

  render() {
    return (
      <Formik
        initialValues={{ email: '' }}
        onSubmit={this.handleSubmit}
        validationSchema={validationSchema}
      >
        {({ isValid, isSubmitting, status }) => {
          return (
            <Form>
              <Box display="flex" flexDirection="column">
                <Text fontSize={1} mb={4}>
                  We’ll email you a link to reset it
                </Text>

                <Field
                  component={InputField}
                  mt={5}
                  mb={4}
                  name="email"
                  type="email"
                  label="Email Address"
                />
                {status && status.message ? (
                  <Text fontSize={1} mb={4} color="green">
                    {status.message}
                  </Text>
                ) : (
                  <Button
                    flex={1}
                    mb={4}
                    type="submit"
                    disabled={!isValid || isSubmitting}
                  >
                    Continue
                  </Button>
                )}
              </Box>
            </Form>
          );
        }}
      </Formik>
    );
  }
}

export default ForgotForm;
